<script>
// import { TheMask } from "vue-the-mask";
import RangeSlider from "vue-range-slider";
// you probably need to import built-in style
import "vue-range-slider/dist/vue-range-slider.css";

import { Money } from "v-money";

export default {
  name: "application-publisher",
  components: {
    // TheMask,
    RangeSlider,
    Money
  },
  data() {
    return {
      types: ["consumer", "vehicle", "realestate"],
      // types: {
      //   consumer: "Personal",
      //   vehicle: "Vehicular",
      //   realestate: "Inmobiliario"
      // },
      application: {
        type: undefined,
        amount: 10000,
        term: 24
      },
      money: {
        decimal: ".",
        thousands: ",",
        prefix: "RD$ ",
        suffix: "",
        precision: 2,
        masked: false /* doesn't work with directive */
      }
    };
  },
  methods: {
    pusher(pushdata) {
      this.$router.push(pushdata);
    }
  },
  watch: {
    type() {
      console.log(this.type);
    }
  },
  filters: {
    termString(val) {
      return val > 1 ? val + " meses" : val + " mes";
    }
  }
};
</script>

<template>
  <div class="view">
    <div class="view__bar">
      <div class="container">
        <div class="row">
          <div class="rowColumn">
            <sapp-back />
            <span class="bar__title">Nueva Aplicación</span>
          </div>
        </div>
      </div>
    </div>
    <div class="view__content">
      <div class="container">
        <div v-if="application.type == undefined" id="publisher-type">
          <!-- <h1 class="title is-4">Seleccione el tipo de préstamo</h1> -->
          <h1 class="title is-4">Tipo de préstamo</h1>
          <div class="options">
            <a class="option" @click.prevent="application.type = 'consumer'">
              <span class="option-icon option-badge"
                ><i class="sappfont sappfont-loan-consumer"></i
              ></span>
              <span class="option-text">Personal</span>
              <span class="option-icon option-arrow"
                ><i class="sappfont sappfont-arrow-right"></i
              ></span>
            </a>
            <a class="option" @click.prevent="application.type = 'vehicle'">
              <span class="option-icon option-badge"
                ><i class="sappfont sappfont-loan-vehicle"></i
              ></span>
              <span class="option-text">Vehicular</span>
              <span class="option-icon option-arrow"
                ><i class="sappfont sappfont-arrow-right"></i
              ></span>
            </a>
            <a class="option" @click.prevent="application.type = 'realestate'">
              <span class="option-icon option-badge"
                ><i class="sappfont sappfont-loan-realestate"></i
              ></span>
              <span class="option-text">Inmobiliario</span>
              <span class="option-icon option-arrow"
                ><i class="sappfont sappfont-arrow-right"></i
              ></span>
            </a>
          </div>
        </div>
        <div v-if="application.type != undefined" id="publisher-details">
          <h1 class="title is-4">Detalles del préstamo</h1>
          <div class="field">
            <p class="question">¿Qué monto deseas financiar?</p>
            <money v-model="application.amount" v-bind="money"></money>
          </div>
          <div class="field">
            <p class="question">¿A qué plazo deseas financiar?</p>
            <div class="term">
              <button
                v-if="application.term < 2"
                class="button term_control term-less disabled"
                disabled
              >
                -
              </button>
              <button
                v-else
                @click="application.term--"
                class="button term_control term-less"
              >
                -
              </button>
              <range-slider
                class="slider"
                min="1"
                max="240"
                step="1"
                v-model="application.term"
              >
              </range-slider>
              <button
                v-if="application.term > 239"
                class="button term_control term-more disabled"
                disabled
              >
                +
              </button>
              <button
                v-else
                @click="application.term++"
                class="button term_control term-more"
              >
                +
              </button>
            </div>
            <span>{{ application.term | termString }}</span>
            <!-- <input type="number" id="term" v-model="application.term" min="1" max="240" step="1"> -->
            <!-- <the-mask type="number" :mask="['###', '(##) #####-####']" v-model="application.term" min="1" max="240" step="1" /> -->
          </div>
          <p>
            <a class="button is-primary is-rounded is-medium" @click.prevent=""
              >Publicar</a
            >
          </p>
          <a @click.prevent="application.type = undefined"
            >Modificar el tipo de prestamo</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.view__content {
  padding: 1rem;
  padding-top: 2rem;
  text-align: center;
  .title {
    font-size: 1rem;
    font-weight: 500;
    margin-bottom: 2rem;
  }
  .field {
    margin-bottom: 4.5rem;
  }
}
#publisher-type {
  .options {
    .option {
      .option-icon {
        width: 4rem;
        height: 4rem;
        border-radius: 2rem;
        // background-color: #4705b1;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        color: #fff;
      }
    }
  }
}
#publisher-details {
  text-align: center;
  .question {
    margin-bottom: 1rem;
  }
  input {
    text-align: center;
    border: none;
    // border-bottom: 2px solid #ccc;
    padding: 0.5rem;
    max-width: 100%;
    font-size: 1.5rem;
  }
  input.v-money {
    height: 3rem;
    border-radius: 1.5rem;
    background-color: #dfe6f4;
    // background-color: transparent;
  }
  .term {
    display: flex;
    align-items: center;
    justify-content: center;
    .term_control {
      background-color: #fff;
      display: block;
      // width: 2rem;
      // line-height: 2rem;
      padding: 0;
      border-radius: 50%;
      font-weight: bold;
      box-shadow: 0 1px 5px 0 rgba(45, 62, 80, 0.12);
      flex: 0 0 2rem;
      height: 2rem;
    }
    .slider {
      width: 20rem;
      max-width: 100%;
    }
  }
}
@media (max-width: 47.9375em) {
  .options {
    .option {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 auto 1.5rem;
      background-color: #4705b1;
      background-color: #4259ed;
      // background: linear-gradient(25deg, #729cf9, #5945db);
      // background: linear-gradient(25deg, #5945db, #4259ed);
      // background: linear-gradient(25deg, #4259ed, #5945db);
      color: #fff;
      max-width: 100%;
      width: 18rem;
      border-radius: 2rem;
      font-weight: bold;
      text-align: center;
      height: 4rem;
      .option-text {
        font-size: 1.25rem;
      }
      i:not(.sappfont-arrow-right) {
        font-size: 2.25rem;
      }
      .sappfont-arrow-right {
        font-size: 1.5rem;
      }
    }
  }
}
@media (min-width: 48em) {
  .view__content {
    text-align: center;
    padding-top: 4rem;
    .title {
      margin-bottom: 4rem;
      font-size: 2rem;
    }
  }
  #publisher-type {
    .options {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      .option {
        display: flex;
        flex-direction: column;
        font-weight: bold;
        color: #5d0dc8;
        .option-icon {
          width: 8rem;
          height: 8rem;
          margin: 0 auto;
          margin-bottom: 1rem;
          border-radius: 4rem;
          display: flex;
          // color: #43dddd;
          background-color: #4705b1;
          background-color: #5d0dc8;
          background-color: $primary;
          // background: linear-gradient(25deg, #729cf9, #5945db);
          i {
            font-size: 5rem;
          }
        }
        .option-arrow {
          display: none;
        }
      }
    }
  }
}
@media (min-width: 64em) {
  .view__content {
    .title {
      margin-bottom: 4rem;
    }
  }
  #publisher-type {
    .options {
      .option {
        .option-icon {
          width: 10rem;
          height: 10rem;
          border-radius: 5rem;
          i {
            font-size: 6rem;
          }
        }
      }
    }
  }
}
</style>
